import { render, staticRenderFns } from "./jsonField.vue?vue&type=template&id=032de65b&"
import script from "./jsonField.vue?vue&type=script&lang=js&"
export * from "./jsonField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports